import { useState, useEffect } from 'react';
import axios from 'axios';
import { getPublicServicesURL } from '../utils/api';

const useGetPublicServices = ({ 
        setErrors
    }) => {
        
    const [ gettingServices, setGettingServices ] = useState(false);
    const [ services, setServices ] = useState([]);
    const [ gettingServicesReqSuccess, setGettingServicesReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingServices) {
            axios.get(getPublicServicesURL).then(result => {
                if (result.status === 200) {
                    const data = result.data.data;
                    setGettingServicesReqSuccess(true);
                    setServices(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingServicesReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingServicesReqSuccess(false);
            }).finally(() => {
                setGettingServices(false);
            });
        }
    }, [gettingServices]);

    return { services, gettingServices, setGettingServices, gettingServicesReqSuccess };
}

export default useGetPublicServices;